import { render, staticRenderFns } from "./DetailSeparator.vue?vue&type=template&id=d35274dc&functional=true&"
import script from "./DetailSeparator.vue?vue&type=script&lang=js&"
export * from "./DetailSeparator.vue?vue&type=script&lang=js&"
import style0 from "./DetailSeparator.vue?vue&type=style&index=0&id=d35274dc&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

export default component.exports